export default __webpack_public_path__ + "static/16-4cd843aecf8bde4d0dd7169fdde8ae49.jpg";